<template>

    <HeaderSection></HeaderSection>
  
<div class="sectionWrapperPurple"  :style="{backgroundColor:jsonContent.profilColor1}">




    <!-- <div v-if="loginStatus == 'true'"> -->
    <div>
        <h1 v-show="!showOrderConfirmation">Cart</h1>
        <h1 v-show="showOrderConfirmation">Confirmation</h1>

<div v-show="cartItems.length < 1">No items</div>

<div class="CartGrid" style="font-weight: bold; border-top:none;">
    <div class="cartColumnd">Qty.</div>
            <div class="cartColumnd">Bundle</div>
            <div class="cartColumnd" style="text-align: right;">Price</div>
            <div style="cursor: pointer;"  class="cartColumnd"></div>
</div>



        <div v-for="(item,index) in  cartItems" :key="item.bundleId"  class="CartGrid"  >
      
            <div class="cartColumnd">{{ item.quantity }}</div>
            <div class="cartColumnd">{{ item.bundleName }}, {{ item.bundPeriode }} days</div>
            <div class="cartColumnd" style="text-align: right;">{{ (parseInt(item.quantity, 10)) * (parseInt(item.bundlePrice, 10))  }},- {{ item.bundlePriceCurrency }}</div>
            <div @click="DeleteItem(index)" style="cursor: pointer; text-align: right;"  class="cartColumnd">X</div>

           
        </div>

        <div class="CartGrid" style="font-weight: bold; border-top:1px solid #fff;">
            <div class="cartColumnd"></div>
            <div class="cartColumnd">Total</div>
            <div class="cartColumnd" style="text-align: right;">{{orderTotal}},- {{jsonContent.currency}}</div>
            <div></div>
</div>
        
    </div>



</div>

<div class="sectionWrapper">

<div v-if="showOrderConfirmation">
    <h2>Your order has been received</h2>
    <h3>Thank You for reserving a World Cruise Data eSIM package</h3>

    <div><strong>Order reference: {{ orderRef }}</strong></div>

    <div style="line-height: 1.5rem; width: 550px; max-width: 90%; margin: auto;">
        <p>
            You will now receive a confirmation email for your order.
            Your eSim will be delivered to your cabin and your onboard account will be charged. 
            Our onboard Guest Services and IT teams can support with setting up your eSim at reception if required. 
            
        </p>


        <p>Please note that if your device is not eSim compatible then we will remove charges from your onboard account.</p>
        
    </div>
    
    <br>
</div>


<div v-if="!showOrderConfirmation">
    <h2>Place your order</h2>

<div>Fill in the form and place your order.</div>


    <div class="formWrapper">
     
        <div class="formLine">
            <label>First name:</label> <input type="text" value="" name="fname" id="fname" required> *
        </div>
            <div class="formLine">
            <label>Last name:</label> <input type="text" value="" name="lname" id="lname" required> *
        </div>
                
        <div class="formLine">
            <label>Booking reference:</label> <input type="text" value="" name="booking" id="booking" :placeholder="jsonContent.bookingRef+'XXXXXX'" required> *
        </div>
            <div class="formLine">
            <label>Email for receiving confirmation (optional)</label> <input style="vertical-align: top;" type="text" value="" name="email" id="email" >
        </div>


        <div class="formLine" v-show="cartItems.length > 0">
            <label></label>     <input type="button"  @click="SendOrder()" value="Place order" >
        </div>

    </div>
</div>



    <div :class="{hideSpinner : (createProfileLink || showDownloadeeSimLink) && !showSpinner}">
      <LoadingSpinner></LoadingSpinner>
    </div>

   
</div>

  
    
     
  
      <FooterSection></FooterSection>
  
  
  
  </template>
  
  
  <style>



.CartGrid {
   
    display: grid;
    grid-template-columns: 1.5fr 8fr 2.5fr 1fr;
    text-align: left;
    width: 500px;
    max-width: 96%;
    margin:0 auto;
    padding: 6px 0;
    border-top: 1px dashed #e3dacf49
}
.CartGrid:hover {
    background-color: rgba(255,255,255,0.1);
}

.cartColumnd {

}



.formWrapper {
    width: 400px;
    max-width: 96%;
    margin:auto;
    padding-top: 30px;
text-align: left;

}
.formLine {
    margin: 6px 0;
}
label {
    width: 150px;
    display: inline-block;
}


  </style>
  
  
  
  
  <script setup>
  
  import { ref, onBeforeMount } from 'vue'
  import HeaderSection from '../components/HeaderSection.vue'
  import FooterSection from '../components/FooterSection.vue'
  import { CartStatus,orderTotal} from '@/modules/modules.js'
  import { useRouter } from 'vue-router'
  import { jsonContent,getContent } from '@/modules/content.js'
  
  const router = useRouter()
  
const cartItems = ref([])
const showSpinner = ref(false);
let cartItemsString = "";
let serverRespone = ref("");
let orderRef = ref();
const showOrderConfirmation = ref(false);
const axios = require('axios');


onBeforeMount(async () => {
  
    getContent(router.currentRoute.value.params.id);
    document.title =   "eSim Portal - " + router.currentRoute.value.params.id.toUpperCase() ;

    if( localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id))
        {
            cartItems.value = JSON.parse(localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id));
            cartItemsString = localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id);
        } 



})


  
function DeleteItem(index){
   console.log(index)
    let cartList = []

    if( localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id) != "")
    {
        cartList = JSON.parse(localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id));
    } 

    cartList.splice(index, 1);
    cartItems.value = cartList
    localStorage.setItem("bundleCart_"+router.currentRoute.value.params.id, JSON.stringify(cartList))
    CartStatus(router.currentRoute.value.params.id)

}



function SendOrder()
{
     let error = false;
     let errorMsg = "";

     let firstname = document.getElementById("fname").value
     let lasname = document.getElementById("lname").value
     let mail = document.getElementById("email").value != null && document.getElementById("email").value != '' ? document.getElementById("email").value : 'NoEmail' 
     let bookingNo = document.getElementById("booking").value;

    if(firstname == '')
    {
        error = true;
        errorMsg += "First name is required \n"
    }
    
    if(lasname == '')
    {
        error = true;
        errorMsg += "Last name is required \n"
    }
    
    if(mail != 'NoEmail')
    {
        if(!isEmail(mail))
    {
        error = true;
        errorMsg += "Fill in a valid e-mail \n"
    }
    }

    
    if(bookingNo == '')
    {
        error = true;
        errorMsg += "Booking reference is required";
    }


    if(error)
    {
        alert(errorMsg);
    }
    else
    {
        //post order
        
       // showSpinner.value = true;
        /**************check profile status*********************/
     //   const axios = require('axios');
const FormData = require('form-data');
let data = new FormData();
data.append('shippingCompany', jsonContent.value.companyName);
data.append('customerFirstName', firstname);
data.append('customerLastName', lasname);
data.append('customerEmail', mail);
data.append('customerBookingNumber', bookingNo);
data.append('orderLines', cartItemsString);
data.append('status', 1);
data.append('urlName', jsonContent.value.urlName);
data.append('orderPrefix', jsonContent.value.orderPrefix);


let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: process.env.VUE_APP_API_EDNPOINT+'/api/portalorder',

  data : data
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
  serverRespone.value = "Your order is sent";
  localStorage.removeItem('bundleCart_'+router.currentRoute.value.params.id);
  //CartStatus()
  orderRef.value = response.data;
  showOrderConfirmation.value = true;
})
.catch((error) => {
  console.log(error);
  serverRespone.value = "An error occurred";
});
        /****************************************/ 

        
        //alert("Sending");
    }
 
}



function isEmail(email) {
            var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        }
  </script>
  
  
  
  